/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RegenerateTokensDto interface.
 */
export function instanceOfRegenerateTokensDto(value) {
    if (!('applicationId' in value) || value['applicationId'] === undefined)
        return false;
    return true;
}
export function RegenerateTokensDtoFromJSON(json) {
    return RegenerateTokensDtoFromJSONTyped(json, false);
}
export function RegenerateTokensDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'applicationId': json['applicationId'],
    };
}
export function RegenerateTokensDtoToJSON(json) {
    return RegenerateTokensDtoToJSONTyped(json, false);
}
export function RegenerateTokensDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'applicationId': value['applicationId'],
    };
}
